/**
 * Keeps popups from piling up on the dashboard. A modal that is optional (install prompt,
 * announcement, coach mark) asks whether another dialog is already open and waits its turn.
 */
import { isEmbedded } from "./embedded";

export function anotherDialogOpen(): boolean {
  if (typeof document === "undefined") return false;
  return !!document.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]');
}

/** Run `fn` once no dialog is open, checking every `everyMs`, giving up after `maxWaitMs`. Returns a cancel function. */
export function whenNoDialog(fn: () => void, opts: { everyMs?: number; maxWaitMs?: number } = {}): () => void {
  if (isEmbedded()) return () => {};  // lessons inside the app: no optional popups at all
  const every = opts.everyMs ?? 4000, maxWait = opts.maxWaitMs ?? 120000;
  const started = Date.now();
  let timer: ReturnType<typeof setTimeout> | null = null;
  const tick = () => {
    if (!anotherDialogOpen()) { fn(); return; }
    if (Date.now() - started > maxWait) return;
    timer = setTimeout(tick, every);
  };
  tick();
  return () => { if (timer) clearTimeout(timer); };
}
